<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import Close from '../../../assets/svgs/close.svelte';

  export let showModal: boolean;
  export let onClose: () => void = () => {};

  let dialog; // HTMLDialogElement
  let mouseDownPos = { x: 0, y: 0 };

  const dispatch = createEventDispatcher();
  $: if (dialog) {
    if (showModal) {
      dialog.showModal();
      dispatch('open');
    } else {
      dialog.close();
      dispatch('close');
    }
  }

  const closeDialog = () => {
    showModal = false;
    dialog?.close();
    dispatch('close');
    onClose();
  };

  const onClickOutside = (e) => {
    e.stopPropagation();
    const rect = dialog.getBoundingClientRect();
    if (
      mouseDownPos.x < rect.left ||
      mouseDownPos.x >= rect.right ||
      mouseDownPos.y < rect.top ||
      mouseDownPos.y >= rect.bottom
    ) {
      closeDialog();
    }
  };
</script>

<!-- svelte-ignore a11y-click-events-have-key-events a11y-no-noninteractive-element-interactions -->
<dialog
  class="max-w-[100vw] md:max-w-[640px] w-full border-0 rounded-tr-xxl rounded-tl-xxl md:rounded-xxl overflow-x-hidden overflow-y-auto bottom-0 top-auto md:top-0"
  bind:this={dialog}
  on:close={closeDialog}
  on:click|self={onClickOutside}
  on:mousedown={(ev) => (mouseDownPos = { x: ev.clientX, y: ev.clientY })}
>
  <!-- svelte-ignore a11y-no-static-element-interactions -->
  <div class="relative mt-auto py-6 px-4 pb-10 md:p-16 bg-white" on:click|stopPropagation>
    <!-- svelte-ignore a11y-autofocus -->

    <button
      data-testid="close-modal"
      class="absolute text-lg font-black p-3 m-2 top-0 right-0 z-50 text-black border-none focus:outline-none"
      on:click={closeDialog}
    >
      <Close />
    </button>

    <slot />
  </div>
</dialog>

<style>
  dialog::backdrop {
    background: rgba(0, 0, 0, 0.9);
    animation: fade-out 300ms ease-out;
    touch-action: none !important;
  }

  dialog[open]::backdrop {
    animation: fade-in 300ms ease-out;
  }

  dialog {
    animation: slide-down 300ms ease-out;
  }

  dialog[open] {
    animation: slide-up 300ms ease-out;
  }

  @media (min-width: 768px) {
    dialog {
      animation: fade-out 300ms ease-out;
    }

    dialog[open] {
      animation: fade-in 300ms ease-out;
    }
  }

  @keyframes fade-in {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  @keyframes fade-out {
    from {
      opacity: 1;
      display: block;
    }
    to {
      opacity: 0;
      display: none;
    }
  }

  @keyframes slide-up {
    0% {
      transform: translateY(100%);
    }
    100% {
      transform: translateY(0);
    }
  }

  @keyframes slide-down {
    from {
      z-index: 99;
      display: block;
      transform: translateY(0);
    }
    to {
      z-index: 99;
      display: none;
      transform: translateY(100%);
    }
  }
</style>
